import { ConditionModalFormValues } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/condition-modal/Condition.types.ts";
import { ConditionModal } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/condition-modal/ConditionModal.tsx";
import { ConditionContext } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/context/ConditionContext.ts";
import { ConditionHelper } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/context/ConditionHelper.ts";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";
import { useStores } from "@stores/hooks/useStores.ts";

interface PrivateConditionModalProps {
  episodeOfCare: EpisodeOfCare;
  onDismiss: () => void;
}

export const PrivateConditionModal: React.FC<PrivateConditionModalProps> = ({
  episodeOfCare,
  onDismiss
}) => {
  const root = useStores();

  const conditionHelper = new ConditionHelper(root, episodeOfCare.patientId, {
    onSubmit: async (
      values: ConditionModalFormValues,
      helper: ConditionHelper
    ) => {
      await helper.submitUpdateConditionValues(
        values,
        values.referralIn
          ? episodeOfCare.nextCalendarEventProviderId
          : undefined
      );
    },
    episodeOfCare
  });

  conditionHelper.showConditionModal(false);

  return (
    <ConditionContext.Provider value={conditionHelper}>
      <ConditionModal onDismiss={onDismiss} />
    </ConditionContext.Provider>
  );
};
